<template>
  <div>
    <base-header class="pb-6" />

    <b-container fluid class="mt--6 max-width">
      <b-card no-body>
        <card-header title="Dataviews">
          <base-button
            size="sm"
            @click="onNewApp"
            v-if="
              (hasAllAccess || hasAccessto.includes('Dataview_all')) &&
              accountSubtype === 'admin'
            "
            >Add Dataview</base-button
          >
        </card-header>

        <el-table header-row-class-name="thead-light" :data="apps">
          <template #empty
            ><span v-if="loading"
              >Loading Dataviews
              <i class="fas fa-sync-alt fa-spin mr-1"></i></span
            ><span v-else>No Dataviews Found</span></template
          >
          <el-table-column
            class-name="font-weight-bold"
            label="Name"
            sortable
            prop="name"
          />
          <el-table-column label="Owner" prop="owner" />
          <el-table-column label="Version" prop="version" />
          <el-table-column :render-header="renderAuthorizedAccountsHeader"
            ><div slot-scope="{ row }">
              {{ row.authorized_accounts.length }}
            </div></el-table-column
          >
          <el-table-column label="Description" sortable prop="description" />

          <el-table-column
            width="300px"
            label="Actions"
            v-if="
              (hasAllAccess || hasAccessto.includes('Dataview_all')) &&
              accountSubtype === 'admin'
            "
          >
            <div slot-scope="{ row }" class="table-actions">
              <base-button size="sm" @click="onDownload(row)"
                ><i class="fas fa-download"></i
              ></base-button>

              <base-button
                @click.native="onAppBuilder(row)"
                class="remove btn-link"
                type=""
                size="sm"
                icon
              >
                <i class="text-dark fas fa-image"></i>
              </base-button>

              <base-button
                @click.native="onEdit(row)"
                class="remove btn-link"
                type=""
                size="sm"
                icon
              >
                <i class="text-dark fas fa-edit"></i>
              </base-button>

              <base-button
                @click.native="onDelete(row)"
                class="remove btn-link"
                type="danger"
                size="sm"
                icon
              >
                <i class="text-white fas fa-trash"></i>
              </base-button>
            </div>
          </el-table-column>
        </el-table>
      </b-card>
    </b-container>
  </div>
</template>

<!-- ###################################################################### -->

<script>
import { Action } from "@/store/actions";
import { mapState, mapGetters } from "vuex";
import { Table, TableColumn } from "element-ui";
import CardHeader from "@/views/components/CardHeader";
import { Routes } from "@/router";
import { confirmDelete, download } from "@/helper";

export default {
  name: "AppList",
  components: {
    CardHeader,
    [Table.name]: Table,
    [TableColumn.name]: TableColumn,
  },
  data() {
    return {
      loading: false,
    };
  },

  computed: {
    ...mapState({
      apps: (state) => state.app.apps,
      isLoading: (state) => state.general.loading,
    }),
    ...mapGetters(["hasAllAccess", "hasAccessto", "accountSubtype"]),
  },

  methods: {
    onDelete(row) {
      confirmDelete().then((result) => {
        if (result.value) {
          this.$store.dispatch(Action.app.delete, row);
        }
      });
    },
    onNewApp() {
      this.$router.push({ name: Routes.appNew });
    },
    onEdit(row) {
      this.$router.push({ name: Routes.appEdit, params: { name: row.name } });
    },
    onAppBuilder(row) {
      // Construct the URL with the dynamic parameter
      const url = `https://dataviewdesigner.infrafon.club?dataview_id=${encodeURIComponent(
        row.name
      )}`;

      // Open the URL in a new tab
      window.open(url, "_blank");
    },
    onDownload(row) {
      download(`${row.name}.json`, JSON.stringify(row.content));
    },
    renderAuthorizedAccountsHeader() {
      return (
        <span>
          Authorized
          <br />
          Accounts
        </span>
      );
    },
  },
  mounted() {
    this.loading = true;
    this.$store
      .dispatch(Action.app.load)
      .then(() => {
        this.loading = false;
      })
      .catch((error) => {
        console.error("Failed to load devices:", error);
        this.loading = false;
      });
  },
};
</script>
